<template>
    <div>
      <div 
          v-if="template_id < 0"
      >
          <b-row class="pb-2">
              <b-col class="col-8">
                  <b-form-input
                  v-model="searchText"
                  placeholder="Type to search"
              />
              </b-col>
              <b-col class="col-4 text-right">
                  <b-button
                  variant="primary"
                  v-on:click="template_id = 0;template_name = '';template_subject = '';"
                  >New template</b-button>
              </b-col>
          </b-row>
          <b-table
              striped
              hover
              :items="templates"
              :fields="templatecolumns"
              :sort-by="'template_name'"
              :sort-desc="true"
              :busy="loading"
              @row-clicked="template_get"
          >
              <template v-slot:cell(actions)="data">
                <b-button
                      variant="primary"
                      class="mr-2"
                      size="sm"
                      title="Edit template"
                      v-on:click="template_id=data.item.id"
                  >
                    <fa-icon name="edit" />
                  </b-button>
                  <b-button
                      variant="secondary"
                      class="mr-2"
                      size="sm"
                      title="Duplicate template"
                      v-on:click="template_duplicate(data.item)"
                  >
                    <fa-icon name="copy" />
                  </b-button>
                  <b-button
                      variant="danger"
                      class="mr-2"
                      size="sm"
                      title="Delete template"
                      v-on:click="template_delete(data.item)"
                  >
                    <fa-icon name="trash" />
                  </b-button>
              </template>
          </b-table>
      
      </div>
      <div 
          v-if="template_id >= 0"
          style="height: 100vh !important"
      >
        <b-overlay :show="saving" spinner>
        <div v-show="templateSaved" class="bg-success py-1 px-2 mb-2" dismissible>
            Template saved
        </div>
        <b-row class="mb-4" sticky>
          <label
            class="col-2 pt-2"
            >Template name:
          </label>     
          <b-form-input
            v-model="template_name"
            inline
            class="form-control col-5"
            autocomplete="off"
          />
          <div class="col-5 text-right">
          <b-btn
            class="mr-2"
            variant="primary"
            v-on:click="template_save"
            :disabled="saving"
          >Save template</b-btn>
          <b-btn
            class="mr-2"
            variant="secondary"
            v-on:click="template_id = -1"
          >Back to list</b-btn>
          </div>
        </b-row>
        <b-row>
          <label
            class="col-2 pt-2"
            >Template e-mail subject:
          </label>     
          <b-form-input
            v-model="template_subject"
            inline
            class="form-control col-5"
            autocomplete="off"
          />          
        </b-row> 
        <EmailEditor
          style="height: 80vh !important"
          ref="emailEditor"
          :options="editorOptions"
          v-on:load="editorLoaded"
          v-on:ready="editorReady"
        />
      </b-overlay>
      </div>

    </div>
  </template>
  
  <script>
    import { EmailEditor } from 'vue-email-editor';

    const cols = [
        { key: 'id', label: 'ID', sortable: true, tdClass: 'col-1', thClass: 'col-1' },
        { key: 'template_name', label: 'Template Name', sortable: true },
        { key: 'actions', label: '', tdClass: 'col-1', thClass: 'col-1' },
    ];
  
    export default {
      name: 'BulkMailDesign',
      components: {
        EmailEditor,
      },
      data() {
        return {
          template_id: -1,
          templates: [],
          loading: false,
          templatecolumns: cols,
          template_name: '',
          template_subject: '',
          searchText: '',
          editorOptions: {
            mergeTags: {
              first_name: {
                name: 'First Name',
                value: '{{firstName}}',
              },
              family_name: {
                name: 'Family Name',
                value: '{{familyName}}',
              },
              email: {
                name: 'Email',
                value: '{{email}}',
              },
              unsubscribe: {
                name: 'Unsubscribe link',
                value: '{{unsubscribe}}',
              }
            },
          },
          editorTools: { },
          templateSaved: false,
          saving: false,
        };
      },
      created() {
        this.templates_get();
      },
      methods: {
        hideBlockbuilderBranding() {
          const elements = document.querySelectorAll('.blockbuilder-branding');
          elements.forEach(element => {
            element.style.display = 'none';
            element.style.height = '0';
          });
        },
        templates_get() {
          // Get the list of templates here
          const filter = {
            deleted: {
              operator: '=',
              value: 0,
            }
          }
          this.$store.dispatch('records_readlist', { table_name: 'g_bulkemailtemplates', filter })
            .then((response) => {
              this.templates = response.data.result;
            });
        },
        template_get(item) {
          this.template_id = item.id;
        },
        async template_save() {
          let html = '';
          this.saving = true;
          await new Promise((resolve) => {
            this.$refs.emailEditor.editor.exportHtml((data) => {
              // console.log('exportHtml', data.html);
              html = data.html;
              resolve();
            });
          });

          this.$refs.emailEditor.editor.saveDesign(async (design) => {
            const data = {
              table_name: 'g_bulkemailtemplates',
              record: {
                template_subject: this.template_subject,
                template_name: this.template_name,
                template_json: JSON.stringify(design),
                template: html,
              },
            }
            if (this.template_id > 0) {
              data.id = this.template_id;
              await this.$store.dispatch('record_put', { id: this.template_id, ...data })
                .then(() => {
                  this.templates_get();
                  this.templateSaved = true;
                  this.saving = false;
                  setTimeout(() => {
                    this.templateSaved = false;
                  }, 2000);
                 });
            } else {
              await this.$store.dispatch('record_post', data)
                .then((response) => {
                  this.templates_get();
                  this.template_id = response.data.id;
                  this.templateSaved = true;
                  this.saving = false;
                  setTimeout(() => {
                    this.templateSaved = false;
                  }, 2000);
                });
            }
          });
        },
        async template_delete(item) {
          if (confirm(`Do you really want to delete the template ${item.template_name}?`)) {
            const record = {
              deleted: 1,
            }
            this.$store.dispatch('record_put', { table_name: 'g_bulkemailtemplates', id: item.id, record })
              .then(() => {
                this.templates_get();
              });
          }
        },
        async template_duplicate(item) {
          this.saving = true;
          await this.$store.dispatch('record_read', { table_name: 'g_bulkemailtemplates', id: item.id })
            .then(async (resp) => {
              let newTemplate = resp.data;
              newTemplate.template_name = `${newTemplate.template_name} (copy)`;
              newTemplate.id = -1;
              const data = {
              table_name: 'g_bulkemailtemplates',
              record: newTemplate,
            }
              await this.$store.dispatch('record_post', data)
                .then((response) => {
                  this.templates_get();
                  this.templateSaved = true;
                  this.saving = false;
                  setTimeout(() => {
                    this.templateSaved = false;
                  }, 2000);
                });
          });
        },
        // called when the editor is created
        editorLoaded() {
          this.hideBlockbuilderBranding();
          this.$store.dispatch('record_read', { table_name: 'g_bulkemailtemplates', id: this.template_id })
            .then((response) => {
              this.template_id = response.data.id;
              this.template_name = response.data.template_name;
              this.template_subject = response.data.template_subject;
              this.$refs.emailEditor.editor.loadDesign(JSON.parse(response.data.template_json));
            });
        },
        // called when the editor has finished loading
        editorReady() {
          this.hideBlockbuilderBranding();
        },
        saveDesign() {
          this.$refs.emailEditor.editor.saveDesign((design) => {
            console.log('saveDesign', design);
          });
        },
        exportHtml() {
          this.$refs.emailEditor.editor.exportHtml((data) => {
            console.log('exportHtml', data);
          });
        },
      },
    };
  </script>
  <style>
    .sticky {
      position: sticky;
      top: 0;
      background-color: white;
      z-index: 1000;
    }
    a.blockbuilder-branding {
      display: none !important;
      height: 0 !important;
    }
</style>